import { CoreLogService } from "../log.service";

/** Brightness */

export interface Brightness {

  /** gets the curent display brightness 
   * value is 0-1 or -1 (system default)
   */
  getBrightness(): Promise<number>;

  /** change the display brightness
   * value is 0-1 or -1 for system default
   */
  setBrightness(value: number): Promise<void>;

  /** hilfsfunktion, setzt die distlay helligkeit, auf die des Systems zurück */
  resetBrightness(): Promise<void>;

  /** lets the screen on */
  setKeepScreenOn(on: boolean): Promise<void>;
}

export class BrightnessCordova implements Brightness {

  /** Brightness */
  constructor(private _coreLogService: CoreLogService) {
  }

  /** gets the curent display brightness 
   * value is 0-1 or -1 (system default)
   */
  public getBrightness(): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      try {
        // cordova.plugins.brightness.getBrightness(resolve, reject); todo kein index.d.ts
        cordova.exec(resolve, reject, "Brightness", "getBrightness", []);
      } catch (ex) {
        this._coreLogService.error("BrightnessCordova", "cordova.plugins.brightness.setBrightness ist fehlgeschlagen.", ex);
        reject(ex);
      }
    });
  }

  /** change the display brightness
   * value is 0-1 or -1 for system default
   */
  public setBrightness(value: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        // cordova.plugins.brightness.setBrightness(value, resolve, reject); todo kein index.d.ts
        cordova.exec(resolve, reject, "Brightness", "setBrightness", [value]);
      } catch (ex) {
        this._coreLogService.error("BrightnessCordova", "cordova.plugins.brightness.setBrightness ist fehlgeschlagen.", ex);
        reject(ex);
      }
    });
  }

  /** hilfsfunktion, setzt die distlay helligkeit, auf die des Systems zurück */
  resetBrightness(): Promise<void> {
    return this.setBrightness(-1);
  }

  /** lets the screen on */
  public setKeepScreenOn(on: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      try {
        // cordova.plugins.brightness.setKeepScreenOn(on, resolve, reject); todo kein index.d.ts
        cordova.exec(resolve, reject, "Brightness", "setKeepScreenOn", [on]);
      } catch (ex) {
        this._coreLogService.error("BrightnessCordova", "cordova.plugins.brightness.setKeepScreenOn ist fehlgeschlagen.", ex);
        reject(ex);
      }
    });
  }
}

export class BrightnessDefault implements Brightness {

  /** Brightness */
  constructor(private _coreLogService: CoreLogService) {
  }

  /** gets the curent display brightness 
   * value is 0-1 or -1 (system default)
   */
  public getBrightness(): Promise<number> {
    this._coreLogService.error("BrightnessDefault", "getBrightness: Brightness not exists.");
    return Promise.reject("Brightness not exists");
  }

  /** change the display brightness
   * value is 0-1 or -1 for system default
   */
  public setBrightness(value: number): Promise<void> {
    this._coreLogService.error("BrightnessDefault", "setBrightness: Brightness not exists.");
    return Promise.reject("Brightness not exists");
  }

  /** hilfsfunktion, setzt die distlay helligkeit, auf die des Systems zurück */
  resetBrightness(): Promise<void> {
    return this.setBrightness(-1);
  }

  /** lets the screen on */
  public setKeepScreenOn(on: boolean): Promise<void> {
    this._coreLogService.error("BrightnessDefault", "setKeepScreenOn: Brightness not exists.");
    return Promise.reject("Brightness not exists");
  }
}
